import { useIsActivityAddOnAvailable } from 'src/modules/checkout/composables/activity-availability/IsActivityAddOnAvailable'
import { computed, toValue } from 'vue'

export function useAvailableActivityAddOns (activityAddOns = []) {
  const { isActivityAddOnAvailable } = useIsActivityAddOnAvailable()

  function computeAvailableActivityAddOns (activityAddOns) {
    return _.filter(toValue(activityAddOns), activityAddOn => isActivityAddOnAvailable(activityAddOn))
  }

  const availableActivityAddOns = computed(() => computeAvailableActivityAddOns(computed(() => activityAddOns)))

  return {
    computeAvailableActivityAddOns,
    availableActivityAddOns
  }
}
